export const tokens = {
    color: {
        coal: '#202323',
        // Is this close enough to: `#161919`?
        void: '#181a1a',
    },
    zindex: {
        item: 1,
        mask: 2,
    },
    list: {
        maxItems: 4,
    },
    item: {
        mask: {
            medium: 2,
            large: 4,
        },
        offset: {
            medium: 8,
            large: 12,
        },
        radius: {
            medium: 9,
            large: 14,
        },
        size: {
            medium: 28,
            large: 42,
        },
    },
    pocket: {
        fontSize: {
            medium: 14,
            large: 18,
        },
    },
};
